export const PERSON_ID_MAX_LENGTH = 50
